module.exports = __webpack_public_path__ + "img/25005616.0cf7a05d.png";